import { Component, Input, OnChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import * as _ from 'lodash';

import { BasePackagingComponent } from '../_base-packaging.component';


@Component({
  moduleId: module.id,
  selector: 'hazardous-materials',
  templateUrl: 'hazardous-materials.component.html',
  styleUrls: ['hazardous-materials.component.scss'],
})
export class HazardousMaterialsComponent extends BasePackagingComponent implements OnChanges {

  @Input() declare itemDetailsData: any;

  @Input() declare data: any;

  @Input() formGroup: UntypedFormGroup;

  language: any;
  generalFields: Array<string> = [
    'hazardous_materials.0.shipping_scope',
    'hazardous_materials.0.bulk',
    'hazardous_materials.0.transport_method',
    'hazardous_materials.0.regulating_country'
  ];
  generalData: Array<any> = [];

  additionalFields: Array<string> = [
    'hazardous_materials.0.shipping_scope',
    'hazardous_materials.0.bulk',
    'hazardous_materials.0.transport_method',
    'hazardous_materials.0.regulating_country'
  ];
  additionalData: Array<any> = [];
  regulatedData: any;

  ngOnChanges() {
    this.prepareData();
  }

  prepareData() {
    const regulatedData = this.separateData(this.data, ['hazardous_materials.0.regulated']);
    this.regulatedData = (<any>regulatedData)['true'];
    const language = this.separateData((<any>regulatedData)['false'], ['language']);
    if (language['true'] && language['true'][0]) {
      this.language = (<any>language)['true'][0];
    } else {
      this.language = 'EN';
    }
    const generalData = this.separateData((<any>language)['false'], this.generalFields);
    this.generalData = (<any>generalData)['true'];
    this.additionalData = (<any>generalData)['false'];
  }

}
